import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import "./Modal.css";

import axios from 'axios';
import swal from 'sweetalert';
import logo1 from "../../../Image/aboutimg.png";
import { BASE_URL } from '../../../insightConfig/insightConfig';

function SubjectSpecificPaymentModal({ setOpen, Amount, ExamType, orders, setPaymentProccessingModal, setPaymentSuccessModal, setTransactionId }) {
    console.log(orders);
    const navigate = useNavigate();
    const EmailId = localStorage.getItem('authtoken');
    const [userpay, setUserpay] = useState('');
    const userDetail = userpay[0]
    useEffect(() => {
        if (!EmailId) return; // Ensure token exists before making the request

        axios.get(`${BASE_URL}/studentdashboard`)
            .then(response => {

                setUserpay(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });

    }, [EmailId]);

    // useEffect(() => {
    //     saveOrderDetails('txn_1234567890');
    // }, []);


    const saveOrderDetails = async (transactionid) => {
        let orderDetails = orders.map(order => ({
            SubjectID: order.Sn,
            amount: (order.Price - (order.Price * order.Discount / 100)),
            TestCount: order.TestCount,
            EmailId: EmailId,
            ExamType: ExamType,
            transactionid,
        }));
        try {
            const response = await axios.post(`${BASE_URL}/ugc/user/saveSubjectSpecificOrders`, orderDetails);
            if (response.data.statusCode == 200) {
                setPaymentProccessingModal(false)
                setPaymentSuccessModal(true);
                setTransactionId(transactionid);
                // navigate("/ugc/paymentsuccess", {
                //     state: {
                //         transactionId: transactionid,
                //         ExamType,
                //         SubjectType: orders?.map(order => order.SubjectType)?.join(', ')
                //     }
                // })
            }

        } catch (error) {
            console.log(error)
        }
    }
    const verifyPayment = async (razorpay_order_id, razorpay_payment_id, razorpay_signature) => {
        const response = await axios.post(BASE_URL + '/paymentVarification', { razorpay_order_id, razorpay_payment_id, razorpay_signature });
        return response.data.success

    }

    const handlePayment = async () => {
        setOpen(false);
        const response = await axios.post(BASE_URL + '/checkout', { amount: /* 100 * Number(Amount) || */ Number(100) });
        var options = {
            key: 'rzp_live_MiLEU5w3lLxTXm', // Enter the Key ID generated from the Dashboard
            amount: response.data.order.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: "INR",
            name: "Insight Edutech Pvt...",
            description: "Test Transaction",
            image: logo1,
            order_id: response.data.order.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            // callback_url: BASE_URL + '/paymentVarification',
            handler: (res) => {
                const isVerified = verifyPayment(res.razorpay_order_id, res.razorpay_payment_id, res.razorpay_signature);
                if (isVerified) {
                    setPaymentProccessingModal(true);
                    setTimeout(() => {
                        saveOrderDetails(res.razorpay_payment_id);
                    }, 1000)
                } else {
                    swal("Invalid Payment Signature!", "Please Try Again", { icon: "error" })
                }
            },
            prefill: {
                name: userDetail?.FirstName || '',
                email: userDetail?.EmailId || '',
                contact: userDetail?.MobileNo || '',
            },
            notes: {
                address: "Razorpay Corporate Office"
            },
            theme: {
                color: "#005bf2"
            }
        };
        const rzpay = new window.Razorpay(options);
        rzpay.open();
    }

    return (
        <>
            <div className="modal-content text-center p-3">
                <div className="modal-header">
                    <h5 className="modal-title">Terms & Conditions</h5>
                    <button type="button" onClick={() => setOpen(false)} className='btn-close' aria-label="Close"></button>
                </div>
                <div className="modal-body">
                    <p>1. Details of a Student: Every student subscribing to any course has to fill/upload the required details on his/her 'Profile' page such as a passport size photo, ID Proof, Address proof, etc. in compliance with the KYC (Know your Customer) requirements mandated by the management of the institute and the regulatory authorities.</p>
                    <Link to="/terms-and-conditions" target='_blank' className='list-group-item fw-bold py-2 text-orange'>Read More...</Link>
                </div>
                <div className="d-grid gap-2">
                    <button type="button" onClick={handlePayment}/*  onClick={() => saveOrderDetails(1, "pay_Ny0x6XWDqUhxz3", "Success")} */ className="btn btn-primary py-3 my-1 fw-bold bg-pureorange proceed-btn">Proceed</button>
                    {/* <button type="button" onClick={()=>handlePaymentSuccess({courseid:CourseID, batchid:BatchID, email:email, amount:payamount, transactionid:"pay_Ny0x6XWDqUhxz3", status:"Success"})} className="btn btn-primary py-3 my-1 fw-bold bg-pureorange proceed-btn">Proceed</button> */}
                </div>
            </div>



        </>
    );
}

export default SubjectSpecificPaymentModal;

